export function updateTitle(n) {
    document.title = n;
}